import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../../login/assets/Group (1).svg";
import { Row, Col, Form, Input, FormGroup, Label, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import RightSide from ".././.././../assets/images/RightSide.png"; // Include your image
import ".././../login/styles/LoginStyle.css";
import ".././.././../styles/CommonStyles.css";
import "./../styles/ForgotPasswordStyle.css";
import strings from "../../../utils/Strings";
import WelcomeComponent from "../../login/components/WelcomeComponent";
import { validateRestPasswordPassword } from "../../../utils/Validation"; // Ensure this function is correctly implemented
import { ResetPasswordRequest } from "../data/request/ResetPasswordRequest";
import { ResetPasswordResponse } from "../data/response/ResetPasswordResponse";
import ForgotPasswordClient from "../data/api/ForgotPasswordApiClient";
import { useApi } from "../../../service/ApiContext";
import { NetworkResponse } from "./.././.././../service/NetworkResponse";
import { useAlert } from "../../../components/AlertContextComponent";
import Loader, {
  LocalStorage,
  RegionLocalStorage,
} from "./../../../utils/Utils";
import { logActionEvent } from "../../../analytics/analytics_utils";
import Logger from "../../../utils/Logger";
import analytics_strings from "../../../analytics/analytics_strings";
import { RegionResponse } from "../../login/data/response/RegionResponse";
import LoginClient from "../../login/data/api/LoginClient";
const ResetPassword: React.FC = () => {
  useEffect(() => {
    Logger.info("ENV:", process.env.REACT_APP_ENVIORNMENT);

    if (process.env.REACT_APP_ENVIORNMENT === strings.environments.prod) {
      const style = document.createElement("style");
      style.innerHTML = `
      .grecaptcha-badge {
        display: block !important;
        position: fixed !important;
        z-index: 9999 !important;
      }
    `;
      document.head.appendChild(style);
    }
  }, []);
  const { token } = useParams<{ token: string }>(); // Extract token from URL parameters
  const { showAlert } = useAlert();

  useEffect(() => {
    Logger.info("Token:", token);
  }, [token]);
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [confirmPasswordError, setConfirmPasswordError] = useState<string>("");

  const api = useApi();
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  useEffect(() => {
    fetchRegion();
  }, []);

  const resetPassword = async () => {
    Loader.showLoading("Loading...");
    const param: ResetPasswordRequest = {
      password: password,
    };
    try {
      const response = await api
        .post<NetworkResponse<ResetPasswordResponse>>(
          ForgotPasswordClient.resetPasswordUrl(token),
          param,
        )
        .then((res) => {
          if (res.data.detail !== null)
            showAlert({
              show: true,
              title: "Success",
              message: res.data.detail,
              button1Text: "OK",
              alertType: "success",
              onlyNeedOneButton: true,
              btn1onPressed: () => navigate(strings.routing.loginPage),
            });
          else {
            showAlert({
              show: true,
              title: "error",
              message: res.data.error,
              button1Text: "OK",
              alertType: "error",
              onlyNeedOneButton: true,
              btn1onPressed: () => navigate(strings.routing.loginPage),
            });
          }
          // setAlertTitle("Success");
          // setAlertMessage("Your password has been reset successfully.");
          // setAlertType("success");
          // setAlertShow(true);
          // setRedirectPath(strings.routing.loginPage);
        })
        .catch((error) => {});
    } catch (e) {
    } finally {
      Loader.dismissLoading();
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Perform validation and get error messages
    const passwordValidationError = validateRestPasswordPassword(
      password,
      confirmPassword,
    );
    if (passwordValidationError) {
      if (
        passwordValidationError ===
        "Password and confirm password does not match."
      ) {
        setPasswordError("");
        setConfirmPasswordError(passwordValidationError);
      } else {
        setPasswordError(passwordValidationError);
        setConfirmPasswordError(passwordValidationError);
      }
    } else {
      setPasswordError("");
      setConfirmPasswordError("");
      logActionEvent(analytics_strings.analytics_events.resetPasswordButton);
      resetPassword();
    }
  };
  const fetchRegion = async () => {
    Loader.showLoading("Loading...");

    try {
      LocalStorage.deleteAllLocalData();
      const response = await api
        .get<RegionResponse>(LoginClient.region)
        .then((res) => {
          const region = res.data.region;
          LocalStorage.setLocalData("region", region);
          Logger.info("region name", res.data.region);
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  useEffect(() => {
    fetchRegion();
  }, []);

  return (
    <div>
      {/* <header className="custom-header">
        <div className="logo-container">
          <img src={logo} alt="logo" className="imageSize" />
        </div>
      </header> */}
      <div className="v2-custom-header">
        <div>
          <img
            src={logo}
            alt="logo"
            style={{
              height: "80px",
              width: "140px",
            }}
          />
        </div>
        <div className="v2-rightside-header">
          <a
            href={process.env.REACT_APP_ABOUTUS_URL}
            target="_blank"
            className="v2-rightside-text"
            style={{ textDecoration: "none", color: "black" }}
          >
            About us
          </a>
          <div className="v2-rightside-text">LMS platform</div>
          <a
            href={process.env.REACT_APP_CONTACTUS_URL}
            target="_blank"
            className="v2-rightside-text"
            style={{ textDecoration: "none", color: "black" }}
          >
            Contact Us
          </a>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "white",
          height: "100vh",
        }}
      >
        {" "}
        <Row>
          <WelcomeComponent />
          <Col lg={6} className="v2-reset-section">
            <div className="v2-reset-wrapper">
              {/* HEADING */}
              <h1 className="v2-reset-heading">
                {strings.resetPassword.heading}
              </h1>

              {/* FORM */}
              <Form className="v2-reset-form" onSubmit={handleSubmit}>
                <Row className="v2-reset-row">
                  {/* PASSWORD */}
                  <Col md={6}>
                    <FormGroup className="v2-reset-form-group">
                      <Label for="password" className="v2-reset-label">
                        {strings.resetPassword.passwordLabel}
                      </Label>

                      <Input
                        type={passwordVisible ? "text" : "password"}
                        name="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={`v2-reset-input ${
                          passwordError && !confirmPasswordError
                            ? "v2-reset-input-error"
                            : ""
                        }`}
                      />
                    </FormGroup>
                  </Col>

                  {/* CONFIRM PASSWORD */}
                  <Col md={6}>
                    <FormGroup className="v2-reset-form-group">
                      <div className="v2-reset-password-header">
                        <Label for="confirmPassword" className="v2-reset-label">
                          {strings.resetPassword.confirmPasswordLabel}
                        </Label>
                      </div>

                      <Input
                        type={passwordVisible ? "text" : "password"}
                        name="confirmPassword"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className={`v2-reset-input ${
                          confirmPasswordError ? "v2-reset-input-error" : ""
                        }`}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* SHOW PASSWORD */}
                <div
                  className="v2-reset-show-password"
                  onClick={togglePasswordVisibility}
                >
                  <i
                    className={`fas ${
                      passwordVisible ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>

                  <span>
                    {passwordVisible ? "Hide Password" : "Show Password"}
                  </span>
                </div>

                {/* ERRORS */}
                <div className="v2-reset-error-container">
                  {confirmPasswordError && (
                    <div className="v2-reset-error">{confirmPasswordError}</div>
                  )}

                  {!confirmPasswordError && passwordError && (
                    <div className="v2-reset-error">{passwordError}</div>
                  )}
                </div>
              </Form>

              {/* BUTTON */}
              <Button
                className={`v2-reset-button ${
                  password.trim() && confirmPassword.trim()
                    ? "v2-reset-button-active"
                    : ""
                }`}
                type="submit"
                onClick={handleSubmit}
              >
                Change password
              </Button>

              {/* BACK TO LOGIN */}
              <p className="v2-reset-back-wrapper">
                <span
                  className="v2-reset-back-link"
                  onClick={() => navigate("/")}
                >
                  {strings.ForgotPassword.backToLoginTxt}
                </span>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ResetPassword;
